/**
 * Phase 3 — complete project.yaml from probe results.
 */

import type { ProbeResult } from "./probe.js";

export function generateProjectYaml(probe: ProbeResult): string {
  const lines: string[] = ["schema: aaac/project/0.1", ""];

  if (probe.existingConfigs.agentContracts) {
    lines.push(`agents: ./${probe.existingConfigs.agentContracts}`, "");
  }

  lines.push(
    "artifacts: ./artifact-contracts.yaml",
    "toolchains: ./toolchain-contracts.yaml",
    "",
    "bindings:",
    "  guardrail:",
    "    - ./bindings/runtime.yaml",
    "  hooks:",
    "    - ./bindings/git.yaml",
    "  observability:",
    "    event_mapping: ./bindings/observability.yaml",
    "    recorder: .cursor/hooks/observ-record.sh",
    "",
    "active_guardrail_policy: default-enforcement",
    "",
    "model_mapping:",
    "  fast:",
    "    adapter: claude",
    "    model: claude-haiku-4-5",
    "  standard:",
    "    adapter: claude",
    "    model: claude-sonnet-4-6",
    "  thinking:",
    "    adapter: claude",
    "    model: claude-opus-4-6",
    "",
    "recovery:",
    "  max_follow_ups: 2",
    "  max_retries: 0",
    "",
    "logging:",
    "  progress_log:",
    "    destination: stderr",
    "",
    "environments:",
    "  git:",
    "    hooks: [pre-commit, pre-push, post-commit]",
    "  cursor:",
    "    hooks_json: .cursor/hooks.json",
    "",
  );

  return lines.join("\n");
}
